import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { sortBy } from 'lodash';
import dayjs from 'dayjs';

import { ApiServiceServerless } from '../../../xhr_libs';
import SmallerLoader from '../../SmallerLoader';
import MonthSelect from '../../MonthSelect2';

const utility_types = ['electric', 'gas', 'water'];

export default function PortfolioManagerMultiModal(props) {
  const { show, onHide, organizationId, accounts, showToast } = props;

  const [isLoading, setIsLoading] = useState(false);

  const [accountIds, setAccountIds] = useState([]);
  const [utilityType, setUtilityType] = useState('electric');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [queryType, setQueryType] = useState(0);

  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);



  useEffect(() => {
    const local_today = dayjs.utc(new Date());
    const local_start_date = dayjs.utc(new Date(local_today.year(), 0, 1));
    setStartDate(local_start_date);
    setEndDate(local_start_date.add(11, 'month'));
    setMinDate(dayjs.utc(new Date(2010, 0, 1)));
    setMaxDate(dayjs.utc(new Date(local_today.year() + 1, 11, 31)));
  }, []);

  const updateSet = (values) => {
    const arr = Array.prototype.slice.call(values);
    const account_ids = arr.map((item) => item.value)
    setAccountIds(account_ids);
  };

  const updatePortfolioManagerMeter = useCallback(
    (organizationId, accountIDs, utilityType, startDate, endDate, queryType) => {
      setIsLoading(true);
      const local_start_date = dayjs.utc(startDate);
      const local_end_date = dayjs.utc(endDate);
      const payload = {
        utility_type: utilityType,
        start_year: local_start_date.year(),
        start_month: local_start_date.month() + 1,
        end_year: local_end_date.year(),
        end_month: local_end_date.month() + 1,
        query_type: queryType,
        account_ids: accountIDs
      };
      ApiServiceServerless.post(
        `/portfolio_manager/meters`,
        payload,
        {
          authorization_id: organizationId,
        }
      )
        .then(() => {
          showToast(
            'success',
            'Success',
            'Account is syncing. This may take a few minutes.'
          );
        })
        .catch((error) => {
          showToast('danger', 'Error', error);
          throw error;
        })
        .finally(() => {
          setIsLoading(false);
          onHide();
        });
    },
    [showToast, onHide]
  );

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton={!isLoading}>
        Sync Portfolio Manager Account
      </Modal.Header>
      <Modal.Body
        style={{ minHeight: '200px', maxHeight: '600px', overflowY: 'auto' }}
      >
        <Form>
          <Form.Group>
            <Form.Label>Utility Account(s)</Form.Label>
            <Form.Control
              as='select'
              multiple
              required
              defaultValue={[]}
              onChange={(e) =>
                updateSet(e.target.selectedOptions)
              }
            >
              {sortBy(accounts, ['account_number']).map((item) => (
                <option key={`acc-opt-${item.id}`} value={item.id}>
                  {item.account_number}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Bill type</Form.Label>
            <Form.Control
              as='select'
              required
              value={utilityType}
              onChange={(e) => setUtilityType(e.target.value)}
            >
              {utility_types.map((type) => (
                <option key={`type-opt-${type}`} value={type}>
                  {type.charAt(0).toUpperCase() + type.substr(1).toLowerCase()}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Bill Date Option
            </Form.Label>
            <Form.Control
              as='select'
              required
              value={queryType}
              onChange={(e) => setQueryType(parseInt(e.target.value))}
            >
              <option key={`month-opt-0`} value={0}>
                Read Date
              </option>
              <option key={`month-opt-1`} value={1}>
                Calender Month
              </option>
            </Form.Control>
          </Form.Group>
          <MonthSelect
            label='Start Date'
            currentDate={startDate}
            setCurrentDate={setStartDate}
            min_date={minDate}
            max_date={maxDate}
            showPicker={true}
          />
          <MonthSelect
            label='End Date'
            currentDate={endDate}
            setCurrentDate={setEndDate}
            min_date={minDate}
            max_date={maxDate}
            showPicker={true}
          />
        </Form>

      </Modal.Body>
      <Modal.Footer>
        {isLoading && <SmallerLoader />}
        <Button
          variant='success'
          disabled={
            utilityType === '' ||
            startDate === '' ||
            endDate === '' ||
            isLoading
          }
          onClick={() =>
            updatePortfolioManagerMeter(
              organizationId,
              accountIds,
              utilityType,
              startDate,
              endDate,
              queryType
            )
          }
        >
          {isLoading ? 'Syncing...' : 'Sync'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
